/**
 * Category cards data — 首頁產品分類卡
 *
 * DEMO: 示意資料，正式資料待客戶/後端。被 components/render-cards.js（renderCategoryCard）消費。
 * 對應資料模型：Category（文章分類 taxonomy，真相源為 platform-categories；產品分類為其視覺呈現）。
 *   欄位定義見 docs/handoff/HANDOFF_BACKEND.md §5 資料模型。
 *
 * 8 張產品分類卡，欄位皆對應原 HTML（href / img / alt / titleEn / titleZh）
 * 待接 backend：分類列表改由 API 提供時，本檔轉為 fetch 後填入相同結構
 *
 * href：分類卡導向產品資料庫列表頁 products.html（醫美療程分類 → 對應產品列表）。
 * 原 ./category/<slug> 為不存在路由（prod 硬 404）；分類專屬篩選頁尚未建置，
 * 統一導 products.html，待後端支援分類參數時改 products.html?cat=<slug>。
 *
 * 值為「頁面檔名」（非 root-絕對 /products）：renderCategoryCard 以
 *   ${import.meta.env.BASE_URL} 前綴成 base-aware 連結（base:'./' → './products.html'）。
 *   與 img 欄位同手法（data 存裸檔名、renderer 補前綴），子目錄部署不 404。
 *   root-絕對 '/products' 在子目錄（…/dist/）會掉前綴 → 打網域根 → 404（render 端 Vite 不改寫 JS 字串）。
 */

export const CATEGORIES = [
  {
    href: 'products.html',
    img: 'category-1.jpg',
    alt: '拉提緊緻',
    titleEn: 'FACIAL LIFTING',
    titleZh: '拉提緊緻',
  },
  {
    href: 'products.html',
    img: 'category-2.jpg',
    alt: '雷射光電',
    titleEn: 'LASER',
    titleZh: '雷射光電',
  },
  {
    href: 'products.html',
    img: 'category-3.jpg',
    alt: '注射療程',
    titleEn: 'INJECTION',
    titleZh: '注射療程',
  },
  {
    href: 'products.html',
    img: 'category-4.jpg',
    alt: '微針電音波',
    titleEn: 'MICRONEEDLING',
    titleZh: '微針電音波',
  },
  {
    href: 'products.html',
    img: 'category-5.jpg',
    alt: '體雕塑形',
    titleEn: 'BODY SCULPTING',
    titleZh: '體雕塑形',
  },
  {
    href: 'products.html',
    img: 'category-6.jpg',
    alt: '醫療保養',
    titleEn: 'SKINCARE',
    titleZh: '醫療保養',
  },
  {
    href: 'products.html',
    img: 'category-7.jpg',
    alt: '頭皮髮質',
    titleEn: 'HAIR & SCALP',
    titleZh: '頭皮髮質',
  },
  {
    href: 'products.html',
    img: 'category-8.jpg',
    alt: '醫美整形',
    titleEn: 'SURGERY',
    titleZh: '醫美整形',
  },
];
